<footer>
  <div class="container-fluid">
    <div class="row footer-banner">
      <div class="col">
        <div class="container-xl">
          <div class="row align-items-center footer-content">
            <div class="col-12 col-lg-7 text-center text-lg-left footer-text">
              <a href="/dental-insurance/home/privacy/">Privacy</a>
              <span class="footer-divider">|</span>
              <a href="/dental-insurance/home/disclaimer/">Disclaimers</a>
              <span class="footer-divider">|</span>
              <a href="/dental-insurance/home/fraud/">Fraud</a>
              <span class="footer-divider">|</span>
              <a href="/dental-insurance/home/sms-texting-policy/">SMS Text</a>
              <span class="footer-divider">|</span>
              <a href="/dental-insurance/home/accessibility/">Accessibility</a>
              <div class="footer-legal">
                &copy; {{ copyrightYear }} United Concordia Companies, Inc. All
                Rights Reserved.
              </div>
              <a
                href="/dental-insurance/about/urac-accreditation/"
                class="d-sm-none footer-legal"
                >URAC Accreditation</a
              >
            </div>
            <div
              class="col-12 col-lg-5 d-flex justify-content-center justify-content-lg-end align-items-center"
            >
              <a
                href="/dental-insurance/about/urac-accreditation/"
                class="urac-logo text-hide d-none d-sm-block"
                >URAC Accreditation</a
              >
              <div class="footer-logo">
                <img src="assets/img/uc-footer.png" width="238px" height="50px" alt="United Concordia Dental logo" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
